import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../../ui/loader/loadable";

// Layout
const BlankLayout = Loadable(lazy(() => import('../../ui/layouts/BlankLayout')));
const FullLayout = Loadable(lazy(() => import('../../ui/layouts/FullLayout')));
const StickyLayout = Loadable(lazy(() => import('../../ui/layouts/StickyLayout')));

// History
const HistoryPoint = Loadable(lazy(() => import('../../modules/main/HistoryPoint')))
const HistoryPointDetail = Loadable(lazy(() => import('../../modules/main/HistoryPoint/detail')))
const HistoryTransaction = Loadable(lazy(() => import('../../modules/main/HistoryTransaction')))
const HistoryTransactionDetail = Loadable(lazy(() => import('../../modules/main/HistoryTransaction/detail')))

// Dashboard
const Home = Loadable(lazy(() => import('../../modules/main/Home')))
const Profile = Loadable(lazy(() => import('../../modules/main/Profile')))
const Stores = Loadable(lazy(() => import('../../modules/main/Store')))
const DetailStore = Loadable(lazy(() => import('../../modules/main/Store/detail')))

// Promo
const PromoHome = Loadable(lazy(() => import('../../modules/main/Promo')))
const PromoDetail = Loadable(lazy(() => import('../../modules/main/Promo/detail')))

// Reservation
const ReservationForm = Loadable(lazy(() => import('../../modules/main/Reservation/form')))
const Reservation = Loadable(lazy(() => import('../../modules/main/Reservation')))
const BrandDashboard = Loadable(lazy(() => import('../../modules/main/Reservation/brand')))

// Auth Component
const Login = Loadable(lazy(() => import('../../modules/auth/Login')))
const Register = Loadable(lazy(() => import('../../modules/auth/Register')));
const ForgotPassword = Loadable(lazy(() => import('../../modules/auth/ForgotPassword')));
const ForgotValidate = Loadable(lazy(() => import('../../modules/auth/ForgotPassword/validate')))
const ForgotSetPassword = Loadable(lazy(() => import('../../modules/auth/ForgotPassword/reset')))

// Policy
const PrivacyPolicy = Loadable(lazy(() => import('../../modules/main/Policy/privacy')))
const AppPolicy = Loadable(lazy(() => import('../../modules/main/Policy/app')))

// Profiles
const ChangePassword = Loadable(lazy(() => import('../../modules/main/ChangePassword')))
const ProfileDetail = Loadable(lazy(() => import('../../modules/main/Profile/profile')))
const FaqMainPage = Loadable(lazy(() => import('../../modules/main/Faq')))
const FaqDetailPage = Loadable(lazy(() => import('../../modules/main/Faq/detail')))


// Top Up
const TopUpDashboard = Loadable(lazy(() => import('../../modules/main/Topup')))
const TopupHistory = Loadable(lazy(() => import('../../modules/main/Topup/detail')))





const appRoute = [
    {
        path: '/',
        element: <StickyLayout />,
        children: [
            { path: '', element: <Home /> },
        ],
    },
    {
        path: 'profiles',
        element: <StickyLayout />,
        children: [
            { path: '', element: <Profile /> },
            { path: 'detail', element: <ProfileDetail /> },
            { path: 'faq', children: [
                {
                    path: '', element: <FaqMainPage />
                },
                {
                    path: 'detail', children: [
                        {
                            path: ':id', element: <FaqDetailPage />
                        }
                    ]
                }
            ] },
            { path: 'privacy-policy', element: <PrivacyPolicy /> },
            { path: 'application-policy', element: <AppPolicy /> },
            { path: 'change-password', element: <ChangePassword /> },
        ],
    },
    {
        path: 'promos',
        element: <FullLayout />,
        children: [
            { path: '', element: <PromoHome /> },
            { path: ':id', element: <PromoDetail /> },
        ],
    },
    {
        path: 'topups',
        element: <FullLayout />,
        children: [
            { path: '', element: <TopUpDashboard /> },
            { path: 'detail', element: <TopupHistory /> },
        ],
    },
    {
        path: 'outlets',
        element: <FullLayout />,
        children: [
            { 
                path: 'brands', 
                children: [
                    {
                        path: '',
                        element: <Stores />,
                    },
                    {
                        path: ':id',
                        element: <Stores />,
                    }
                ], 
            },
            { path: ':id', element: <DetailStore /> }
        ],
    },
    {
        path: 'reservations',
        element: <FullLayout />,
        children: [
            { path: '', element: <Reservation /> },
            { path: 'brands', element: <BrandDashboard /> },
            { path: 'outlet/:outletName/:outletId', element: <ReservationForm /> }
        ],
    },
    {
        path: 'histories',
        element: <FullLayout />,
        children: [
            { path: 'transaction', element: <HistoryTransaction /> },
            { path: 'transaction/detail', element: <HistoryTransactionDetail /> },
            { path: '', element: <HistoryPoint /> },
            { path: 'detail', element: <HistoryPointDetail /> }
        ],
    },
    {
        path: 'auths',
        element: <BlankLayout />,
        children: [
            { path: 'login', element: <Login /> },
            { path: 'register', element: <Register /> },
            { path: 'forgot-password', element: <ForgotPassword />},
            { path: 'forgot-validate', element: <ForgotValidate />},
            { path: 'forgot-reset', element: <ForgotSetPassword />}
        ],
    },
    { 
        path: '*', element: <Navigate to="/auths/login" /> 
    },
]

export default appRoute;